export { getServerSideProps } from '@framework/ssr/category';
import { getLayout } from '@components/layouts/layout';
import dynamic from 'next/dynamic';
import { isMobileOnly } from 'react-device-detect';
import { getLayout as getSiteLayoutMobile } from '@components/layouts/layout-mobile';

const Category = dynamic(() => import("@components/categories/category"));

export default function Categories({ data }: any) {
  return <Category id={data?.id} />;
}

const getLayoutMobile = (page: React.ReactElement) =>
  getSiteLayoutMobile(
    <>{page}</>
  );

Categories.getLayout = isMobileOnly ? getLayoutMobile : getLayout;
